import {
	useMutation,
	UseMutationOptions,
	useQuery,
	UseQueryOptions,
} from "@tanstack/react-query";

import { CoreApi } from "../helpers/Http";
/**
 *  Authorization 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetAuthorization = (callAuthenticate : any, options?: UseQueryOptions) => {
    const queryFn = async () => await CoreApi.get(`/authentication`);
  
    return useQuery({
        queryKey: ['authentication', callAuthenticate],
        queryFn,
        enabled: !!Boolean(callAuthenticate),
        refetchOnWindowFocus: false,
      });
};

/**
 * Generate Authorization Token
 *
 * @param payload
 * @param options
 * @returns
 */

export const usePostGenerateAuthorizationToken = (
    options?: UseMutationOptions
) => {
	
    const mutationFn = async (payload: any) =>
		await CoreApi.post(`login?code=${payload.token}`);

	return useMutation({ mutationFn });
};

/**
 * Generate Authorization Token
 *
 * @param payload
 * @param options
 * @returns
 */

export const useSignOut = (
    options?: UseMutationOptions
) => {
	
    const mutationFn = async (payload: any) =>
		await CoreApi.post(`logout`, payload);

	return useMutation({ mutationFn });
};